import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import InvitationMessage from './components/InvitationMessage/InvitationMessage';
import EventDetails from './components/EventDetails/EventDetails';
import Countdown from './components/Countdown/Countdown';
import ParentsSection from './components/ParentsSection/ParentsSection';
import Schedule from './components/Schedule/Schedule';
import RSVP from './components/RSVP/RSVP';
import ThankYou from './components/ThankYou/ThankYou';
import AudioPlayer from './components/AudioPlayer';
import DressCode from './components/DressCode/DressCode';
import Envelope from './components/Envelope/Envelope';
import './App.css';

const MainContent: React.FC = () => {
  const [isEnvelopeOpen, setIsEnvelopeOpen] = useState(false);

  const handleEnvelopeOpen = () => {
    setIsEnvelopeOpen(true);
  };

  return (
    <>
      {!isEnvelopeOpen && (
        <Envelope 
          onOpen={handleEnvelopeOpen}
        />
      )}
      
      <Header />
      <InvitationMessage />
      <ParentsSection />
      <Countdown />
      <EventDetails />
      <Schedule />
      <DressCode />
      <RSVP />
      <ThankYou />
      <AudioPlayer />
    </>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<MainContent />} />
          <Route path="/:familyId" element={<MainContent />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;